import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import {React, useRef, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext/AuthContext";
import { api_Routes } from "../../../api_Routes";
import { Helper } from "../../../tools/Helper";
import { Styles } from "./styles";
import {FormControl, InputAdornment, InputLabel, MenuItem, Select} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";

const AddGroup = () => {
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
  const { showCenteredPopup } = useCenteredSnackbar();
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [IsLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    url: "",
    owner: "",
    type: "",
  });

  const action = key => (
      <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
  );
  const types = [
    'Whatsapp',
    'Telegram',
    'Skype'
  ]

  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);


  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };


  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleCategoryChange = (value) => {
    setFormData(prevFormData => ({
      ...prevFormData,type: value        // Update countTicket to 1
    }));
    console.log(formData)
  };
  const handleButtonClick = async () => {
    // if (!auth) {
    //   enqueueSnackbar("please login first ", { variant: "warning" ,
    //           persist: true,
    //           action,});
    //   navigate("/login", { state: { from: location } });
    // } else {
      await handleSubmit();
    // }
  };
  const handleSubmit = async () => {
    if (!captchaToken) {
      showCenteredPopup("Please complete the CAPTCHA",
          { variant: "error",
            persist: true });
      // enqueueSnackbar("Please complete the CAPTCHA", {variant: "error",
      //   persist: true,
      //   action,});
      return;
    }
    const requiredFields = ["title","url","type","owner"];

    const updatedFormData = {
      ...formData,
    };

    const missingFields = requiredFields.filter(
      (field) => !updatedFormData[field]
    );



    if (missingFields.length > 0) {
      showCenteredPopup(`Please fill in all required fields: ${missingFields.join(", ")}`,
          { variant: "error",
            persist: true });
      // enqueueSnackbar(
      //   `Please fill in all required fields: ${missingFields.join(", ")}`,
      //   {
      //     variant: "error",
      //     persist: true,
      //     action,
      //     anchorOrigin: {
      //       vertical: "top",
      //       horizontal: "right",
      //     },
      //   }
      // );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const form_data = new FormData();

    // Append other form data fields
    Object.keys(updatedFormData).forEach((key) => {
      const value = updatedFormData[key];
        if (formData[key] !== "" && formData[key] !== null)
          form_data.append(key, updatedFormData[key]);

    });
    const { response, message } = await Helper.Post({
      url: api_Routes.SocialGroup.AddGroup,
      data: form_data,
      hasToken: true,
    });

    if (response) {
      showCenteredPopup(message,
          { variant: "success",
            persist: true });
      // enqueueSnackbar(message, {
      //   variant: "success",
      //   persist: true,
      //   action,
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      // navigate("/");
      setIsLoading(false);
    }
    else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      showCenteredPopup(errorMessage,
          { variant: "error",
            persist: true });
      // enqueueSnackbar(errorMessage, {
      //   variant: "error",
      //   persist: true,
      //   action,
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      setIsLoading(false);
    }
  };

  const formStyles = {
    sectionTitle: {
      color: "#2d3748",
      fontWeight: 600,
      fontSize: "1.5rem",
      mb: 3,
    },
    textField: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        "& fieldset": { borderColor: "#e2e8f0" },
        "&:hover fieldset": { borderColor: "#cbd5e0" },
        "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
      },
      "& .MuiInputLabel-root": {
        color: "#718096",
        fontSize: "0.875rem",
      },
      "& .MuiInputBase-input": {
        fontSize: "0.875rem",
        padding: "12px 14px",
      },
    },
    submitButton: {
      background: "linear-gradient(45deg, #3b82f6 30%, #60a5fa 90%)",
      color: "white",
      fontWeight: 600,
      fontSize: "1rem",
      px: 6,
      py: 1.5,
      borderRadius: "8px",
      boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.2)",
      "&:hover": {
        boxShadow: "0 10px 15px -3px rgba(59, 130, 246, 0.3)",
      },
    },
  };
  return (
    <Styles>
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: "#1e293b",
              mb: 2,
              fontSize: { xs: "2rem", md: "2.5rem" },
            }}
          >
            Add Your Own Social Group
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#64748b",
              maxWidth: 600,
              mx: "auto",
              fontSize: "1.1rem",
            }}
          >
            Expand your reach by adding your Social Group to our comprehensive database
          </Typography>
        </Box>

        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 3,
            p: { xs: 3, md: 4 },
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Main Details Section */}
          <Box mb={5}>
            <Typography sx={formStyles.sectionTitle}>
              Social Media Group Information
            </Typography>

            <Grid container spacing={3} style={{padding:10}}>
              <Grid item xs={12}>
                <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{
                      boxShadow: "1px 2px 4px #454040",
                      borderRadius: "8px",
                      background: "#F5F8FE",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "&:hover fieldset": {
                          borderColor: "#6B9DFE",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#007BFF",
                        },
                      },
                    }}
                >
                <InputLabel
                    id="select-category-label"
                    sx={{
                      color: "#474747",
                      fontSize: "16px",
                      fontWeight: "500",
                      lineHeight: "20px",
                      "&.Mui-focused": {
                        color: "#007BFF",
                      },
                    }}
                >
                  Type
                </InputLabel>
                <Select
                    labelId="select-category-label"
                    id="select-category"
                    value={formData.type}
                    onChange={(e) => {
                      handleCategoryChange(e?.target?.value);
                    }}
                    displayEmpty
                    label="Select Category"
                    sx={{
                      "& .MuiSelect-select": {
                        padding: "10px 12px",

                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiSelect-icon": {
                        color: "#707275",
                      },
                      "& .MuiMenu-paper": {
                        maxHeight: "200px",
                        backgroundColor: "#f5f8fe",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        "& .MuiMenuItem-root": {
                          padding: "10px",
                          color: "#333",
                          fontSize: "14px",
                          borderBottom: "1px solid #9E9E9E",
                          '&[aria-selected="true"]': {
                            backgroundColor: "#007bff",
                            color: "#fff",
                          },
                          '&[data-focus="true"]': {
                            backgroundColor: "#007bff",
                          },
                        },
                      },
                      "&::-webkit-scrollbar": {
                        width: "8px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#F5F8FE",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#004571",
                        borderRadius: "4px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#004571",
                      },
                    }}
                    inputProps={{
                      "aria-label": "Select Category",
                    }}
                >
                  {/* Replace Categories with your actual category data array */}
                  {types.map((option) => (
                      <MenuItem
                          key={option}
                          value={option}
                          sx={{
                            padding: "10px",
                            color: "#333",
                            fontSize: "14px",
                            borderBottom: "1px solid #9E9E9E",
                          }}
                      >
                        {option}
                      </MenuItem>
                  ))}
                </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Title"
                  variant="outlined"
                  required
                  onChange={(e) => handleChange("title", e.target.value)}
                  sx={formStyles.textField}

                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Owner"
                  variant="outlined"
                  required
                  onChange={(e) => handleChange("owner", e.target.value)}
                  sx={formStyles.textField}

                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Url"
                  variant="outlined"
                  required
                  onChange={(e) => handleChange("url", e.target.value)}
                  sx={formStyles.textField}

                />
              </Grid>
            </Grid>
          </Box>

          <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
              }}
          >
            <ReCAPTCHA
                sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
                ref={recaptchaRef}
            />
          </Box>

          {/* Submit Button */}
          <Box textAlign="center" mt={6}>
            <Button
              variant="contained"
              onClick={handleButtonClick}
              disabled={IsLoading}
              sx={formStyles.submitButton}
            >
              {IsLoading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Submit Group"
              )}
            </Button>
          </Box>
        </Box>
      </Container>
    </Styles>
  );
};

export default AddGroup;
